var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkspaceDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 495,
    height: 495,
    rx: 17.5,
    fill: "#FAFAFF",
    stroke: "#F2F2F6",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M343.325 197.133C346.554 197.133 348.859 194.909 348.859 191.797V159.336C348.859 156.223 346.554 154 343.325 154C340.097 154 337.791 156.223 337.791 159.336V191.797C337.791 194.909 340.558 197.133 343.325 197.133Z",
    fill: "#C8D3DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M326.724 179.789H359.466C362.694 179.789 365 177.566 365 174.453C365 171.341 362.694 169.117 359.466 169.117H326.724C323.495 169.117 321.19 171.341 321.19 174.453C321.19 177.566 323.495 179.789 326.724 179.789Z",
    fill: "#C8D3DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M157.017 206.025H189.759L199.905 187.794C201.75 184.236 205.9 181.568 210.051 181.568H275.994C279.683 181.568 282.912 183.347 285.217 186.46L297.208 206.025H329.95C341.94 206.025 352.086 215.808 352.086 227.814V309.632C352.086 321.638 342.402 331.421 329.95 331.421H157.017C145.027 331.421 134.881 321.638 134.881 309.632V227.814C134.881 215.808 145.027 206.025 157.017 206.025ZM243.715 311.413C267.696 311.413 287.065 291.403 287.065 267.391C287.065 243.379 267.696 223.369 243.715 223.369C219.735 223.369 200.366 243.379 200.366 267.391C200.366 291.403 219.735 311.413 243.715 311.413ZM152.864 235.378C156.553 235.378 159.781 232.265 159.781 228.263C159.781 224.261 156.553 221.149 152.864 221.149C149.175 221.149 145.946 224.261 145.946 228.263C145.946 232.265 149.175 235.378 152.864 235.378Z",
    fill: "#C8D3DC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.658 303C263.705 303 279.956 286.882 279.956 267C279.956 247.118 263.705 231 243.658 231C223.611 231 207.359 247.118 207.359 267C207.359 286.882 223.611 303 243.658 303Z",
    fill: "#C8D3DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspaceDefault);
export default __webpack_public_path__ + "static/media/workspace-default.df4929d457e58f795223db6932efd81b.svg";
export { ForwardRef as ReactComponent };